/* Package JSON Import will be here */
import React, { useState } from "react";
import { getTranslate } from "react-localize-redux";
import { useSelector, useDispatch } from "react-redux";
import { Modal, Button, Spin, Typography, Input } from "antd";
/* Package JSON Import will be here */

/* Project Import will be here */
import TooltipComp from "components/reusable/TooltipComp";
import BarCodeScanner from "components/reusable/BarCodeScanner";
import { getProductByBarCode } from "reducers/searchProducts";
import { ISearchProductParams } from "models/homeModels";
import { appRoutesConst } from "app/navigation";
import { GABarCodeSearchInitiation } from "hooks/googleAnalyticsHooks";
/* Project Import will be here */

/* Const,Let & Var will be here */
const { Text } = Typography;
let isScanningInprogress = false;
let errorResponseCount = 0;
/* Const,Let & Var will be here */

const BarCodeSearchProducts = (props) => {
    const [isShowBarCodeScannerModal, setIsShowBarCodeScannerModal] = useState(false);
    const [isCameraInitializing, setIsCameraInitializing] = useState(false);
    const [barCodeText, setBarCodeText] = useState("");
    const [hideCamera, setHideCamera] = useState(false);

    const { searchProducts, router, common, translate } = useSelector((state) => ({
        searchProducts: state.searchProducts,
        router: state.router,
        common: state.common,
        translate: getTranslate(state.locale)
    }));

    const dispatch = useDispatch();

    const showOrHideBarCodeScannerModal = () => {
        /* Show loader on camera initializing */
        if (!isShowBarCodeScannerModal) {
            setIsCameraInitializing(true);

            /* After 1.5 sec hide the camera initializing loader */
            setTimeout(() => {
                setIsCameraInitializing(false);
            }, 1500);
        }

        setIsShowBarCodeScannerModal(!isShowBarCodeScannerModal);
        setBarCodeText("");
        setHideCamera(false);
        errorResponseCount = 0;

        /* GA - Track barcode initialization */
        if (window.isEnableGA)
            GABarCodeSearchInitiation();
    }

    const checkIsFromSalesReturn = () => {
        let path = router.location.pathname;
        if ((path.includes(appRoutesConst.salesReturn)) || (path.includes(appRoutesConst.salesReturnProducts)) || (path.includes(appRoutesConst.salesReturnSummary)) || (path.includes(appRoutesConst.salesReturnHistory)) || (path.includes(appRoutesConst.salesReturnHistoryDetails)))
            return true;
        else
            return false;
    }

    const successResponseCallback = () => {
        setIsShowBarCodeScannerModal(false);
        props.setIsShowSearchDrawer(false);
        isScanningInprogress = false;
    }

    const errorResponseCallback = (isFromScan) => {
        isScanningInprogress = false;

        /* Check for submit resource */
        if (isFromScan) {
            errorResponseCount = errorResponseCount + 1;
            /* if the error response count reached 5 then show the message and hide the camera */
            if (errorResponseCount === 3)
                setHideCamera(true);
        }
    }

    const getBarcodeResult = (code, isFromScan) => {
        const requestObj: ISearchProductParams = {
            SearchText: code,
            NeedSalesReturn: checkIsFromSalesReturn() ? true : null,
            NeedFOC: common.isFocSelected
        };
        dispatch(getProductByBarCode(requestObj, successResponseCallback, errorResponseCallback, isFromScan));
    }

    const onBarCodeDetected = (result) => {
        if (result.codeResult.code !== "" && !isScanningInprogress) {
            isScanningInprogress = true;
            getBarcodeResult(result.codeResult.code, true);
        }
    }

    const onBarcodeSubmit = () => {
        getBarcodeResult(barCodeText, false);
    }

    const getModelFooter = () => {
        const footerArray = [];

        /* Cancel button by default */
        footerArray.push(
            <Button key="cancel" size="large" onClick={showOrHideBarCodeScannerModal}>
                {translate("common.buttons.cancel")}
            </Button>
        );

        /* Submit button based on entered barcode */
        if (barCodeText !== "") {
            footerArray.push(
                <Button key="submit" size="large" type="primary" onClick={onBarcodeSubmit}>
                    {translate("common.buttons.submit")}
                </Button>
            );
        }

        return footerArray;
    }

    return (
        <React.Fragment>
            <TooltipComp title={translate("products.productLabel.scanProducts")}>
                <Button
                    type="primary"
                    shape="circle"
                    onClick={showOrHideBarCodeScannerModal}
                    className="mt-12-px"
                    icon={<i className="fa fa-barcode fa-lg cursor-pointer" aria-hidden="true"></i>}
                />
            </TooltipComp>

            {isShowBarCodeScannerModal &&
                <Modal
                    title={translate("products.productLabel.scanProducts")}
                    width={600}
                    centered
                    maskClosable={false}
                    visible={isShowBarCodeScannerModal}
                    onCancel={showOrHideBarCodeScannerModal}
                    className="barcode-scanner-modal"
                    closeIcon={<i className="fa fa-times-circle fa-lg modal-close-button-icon" aria-hidden="true"></i>}
                    footer={getModelFooter()}
                >
                    <Spin
                        tip={isCameraInitializing ? translate('products.barCodeScanner.initCamera') : translate('products.barCodeScanner.scanning')}
                        spinning={isCameraInitializing || searchProducts.isBarCodeLoading}
                    >
                        {!hideCamera ?
                            <React.Fragment>
                                <BarCodeScanner onDetected={onBarCodeDetected} />
                                <div className="pt-3"><Text className="font-12" type="warning">{translate("common.header.search.cameraAccessNote")}</Text></div>
                                <div className="text-center p-2"><Text className="font-12" type="bold">({translate("products.productLabel.or")})</Text></div>
                            </React.Fragment>
                            :
                            <div className="p-3"><Text className="font-12" type="danger">{translate("common.alerts.error.unableToRecognizeBarCode")}</Text></div>
                        }
                        <Input
                            value={barCodeText}
                            onChange={(e) => { setBarCodeText(e.target.value); }}
                            size="large"
                            className="border-radius-15"
                            placeholder={translate("common.header.search.searchByBarcodeText")}
                        />
                    </Spin>
                </Modal>
            }
        </React.Fragment>
    );
};

export default BarCodeSearchProducts;